import { ButtonConfig } from "../button/button.config";

interface ISplitbuttonConfig  {
    // kept for future extensions
}

export class SplitbuttonConfig extends ButtonConfig implements ISplitbuttonConfig {
    // kept for future extensions
}